<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="已完成"
      :page="page"
      :get-data-func="api.list"
      :queryParamsAppend="{ProductionStatus: 1, IsCloth: true}"
      urlHash="production/clothmanagement/completed"
      @selectClick="selectClick"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/production/clothProduction').default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
    };
  },
  
  methods: {
    selectClick(data){
      let OrderNo  = data.OrderNo;
      this.goPage(OrderNo)
    },
    async goPage(OrderNo){
      let params = {};
      let res = null;

      params.OrderNo = OrderNo;
      res = await this.sourceTypeApi.info("销售订单");
      params.SourceType = res.SourceType;
      this.$router.push({ name: "saleorder", params: params });
    },
   queryFunc(params){
      this.$refs.list.query(params, 'queryVerify')
    }
  },
};
</script>
